import { useEffect, useState } from 'react'
import { Col, Form, OverlayTrigger, Row, Table, Tooltip } from 'react-bootstrap'
import {
  ArrowClockwise,
  CheckCircleFill,
  PencilFill,
  PlusCircleFill,
  Search,
  TrashFill,
} from 'react-bootstrap-icons'
import { toast } from 'react-toastify'
import { Ask } from '../../../../components/Ask'
import { Center as CenterContent } from '../../../../components/Center'
import { CustomButton } from '../../../../components/CustomButton'
import { CustomSpinner } from '../../../../components/CustomSpinner'
import { useOrdenation } from '../../../../hooks/useOrdenation'
import WMSTipoOSService from '../../../../services/database/WMSTipoOSService'
import { areObjEqual } from '../../../../utils/obj'
import { sendErrorApiMessage } from '../../../../utils/sendErrorApiMessage'
import { ModalCreate } from './ModalCreate'
import { Center, Container, GroupX } from './styles'

export function TiposOS() {
  const [tipos, setTipos] = useState([])
  const [isTiposLoading, setIsTiposLoading] = useState(true)
  const [search, setSearch] = useState('')
  const [isModalCreateOpen, setIsModalCreateOpen] = useState(false)

  const { filteredItems, Th, Paginate } = useOrdenation(tipos, 'id')

  async function handleSearch() {
    try {
      setIsTiposLoading(true)

      const data = await WMSTipoOSService.search({ search })

      setTipos(data)
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao pesquisar os tipos!')
    } finally {
      setIsTiposLoading(false)
    }
  }

  async function loadTipos() {
    try {
      setIsTiposLoading(true)

      const data = await WMSTipoOSService.getAll()

      console.log(data)

      setTipos(data)
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao carregar os tipos!')
    } finally {
      setIsTiposLoading(false)
    }
  }

  useEffect(() => {
    loadTipos()
  }, [])

  return (
    <>
      <Container>
        <h1>Tipos de OS (tipoos)</h1>

        <>
          <GroupX>
            <CustomButton
              title="Cadastrar Tipo"
              color="#0d9a04"
              onClick={() => setIsModalCreateOpen(true)}
            >
              <PlusCircleFill />
            </CustomButton>

            <CustomButton
              title="Recarregar"
              onClick={() => {
                setSearch('')
                loadTipos()
              }}
            >
              <ArrowClockwise />
            </CustomButton>
          </GroupX>

          <CenterContent className="mt-4">
            <Form.Control
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Digite..."
              onKeyDown={(e) => {
                if (e.key === 'Enter' && search) {
                  handleSearch()
                }
              }}
            />

            <CustomButton
              title="Pesquisar"
              onClick={handleSearch}
              isDisabled={isTiposLoading || !search}
            >
              <Search />
            </CustomButton>
          </CenterContent>

          {isTiposLoading ? (
            <Center className="mt-3">
              <CustomSpinner size={48} />

              <h1>Carregando...</h1>
            </Center>
          ) : filteredItems.length === 0 ? (
            <p className="mt-3">Sem tipos</p>
          ) : (
            <>
              <Table>
                <thead>
                  <tr>
                    <Th
                      value="id"
                      label="ID"
                    />
                    <Th
                      value="descricao"
                      label="Descrição"
                    />
                    <Th label="Ações" />
                  </tr>
                </thead>
                <tbody>
                  {filteredItems.map((tipo) => (
                    <Tipo
                      key={tipo.id}
                      tipo={tipo}
                      loadTipos={loadTipos}
                    />
                  ))}
                </tbody>
              </Table>

              <Paginate />
            </>
          )}
        </>
      </Container>

      {isModalCreateOpen && (
        <ModalCreate
          isOpen={isModalCreateOpen}
          onClose={() => setIsModalCreateOpen(false)}
          loadTipos={loadTipos}
        />
      )}
    </>
  )
}

function Tipo({ tipo, loadTipos }) {
  const [data, setData] = useState(tipo)
  const [isDeleteRequestLoading, setIsDeleteRequestLoading] = useState(false)
  const [isUpdateRequestLoading, setIsUpdateRequestLoading] = useState(false)
  const [isEditMode, setIsEditMode] = useState(true)

  function handleChange(e) {
    const { name, value } = e.target

    setData((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }

  async function handleUpdateTipo(id) {
    try {
      setIsUpdateRequestLoading(true)

      await WMSTipoOSService.update(id, data)

      loadTipos()
      toast.success('Tipo atualizado com sucesso!')
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao atualizar o tipo!')
    } finally {
      setIsUpdateRequestLoading(false)
    }
  }

  async function handleDeleteTipo(id) {
    try {
      setIsDeleteRequestLoading(true)

      await WMSTipoOSService.delete(id)

      loadTipos()
      toast.success('Tipo deletado com sucesso!')
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao deletar o tipo!')
    } finally {
      setIsDeleteRequestLoading(false)
    }
  }

  return (
    <tr>
      <td>{data.id}</td>

      <td>
        <Row>
          <Col>
            <Form.Control
              name="descricao"
              value={data?.descricao}
              onChange={handleChange}
              disabled={isEditMode}
            />
          </Col>

          <Col>
            <Form.Select
              name="tipoos"
              value={data?.tipoos}
              onChange={handleChange}
              disabled={isEditMode}
            >
              <option value="">Selecione</option>
              <option value="E">Entrada</option>
              <option value="S">Saída</option>
              <option value="T">Transferência</option>
              <option value="I">Inventário</option>
            </Form.Select>
          </Col>
        </Row>
      </td>

      <td>
        <CenterContent>
          <OverlayTrigger overlay={<Tooltip>Editar</Tooltip>}>
            <CustomButton
              noMargin
              isLoading={!isEditMode && isUpdateRequestLoading}
              color={isEditMode ? 'orange' : 'green'}
              onClick={() =>
                isEditMode
                  ? setIsEditMode(false)
                  : areObjEqual(data, tipo)
                    ? setIsEditMode(true)
                    : handleUpdateTipo(data.id)
              }
            >
              {isEditMode ? <PencilFill /> : <CheckCircleFill />}
            </CustomButton>
          </OverlayTrigger>

          <OverlayTrigger overlay={<Tooltip>Deletar</Tooltip>}>
            <CustomButton
              noMargin
              color="red"
              isLoading={isDeleteRequestLoading}
              onClick={() =>
                Ask('Deseja excluir o tipo?', () => handleDeleteTipo(tipo.id))
              }
            >
              <TrashFill />
            </CustomButton>
          </OverlayTrigger>
        </CenterContent>
      </td>
    </tr>
  )
}
